export interface BrowserStorage {
  getItem: (key: string) => null | string;
  setItem: (key: string, value: string) => void;
  removeItem: (key: string) => void;
  clear(): void;
}

export const browserStorage: BrowserStorage = window.localStorage;
